import hisrequest from '@/utils/hisrequest'
import authrequest from '@/utils/authrequest'
import { getHospital } from '@/services/inst.service'

// 获取医院信息
export function getInstInfo() {
  return hisrequest({
    url: '/inst/info',
    method: 'get'
  })
}

// 本地HIS相关接口
export function getPatientData(idcard, instid, admvs, insuplc_admvs) {
  // 获取当前日期，格式：YYYY-MM-DD
  const today = new Date()
  const year = today.getFullYear()
  const month = String(today.getMonth() + 1).padStart(2, '0')
  const day = String(today.getDate()).padStart(2, '0')
  const begntime = `${year}-${month}-${day} 00:00:01`
  
  let data = {
        "mdtrt_cert_type": "02",
        "mdtrt_cert_no": idcard,
        "card_sn": "",
        "begntime": begntime,
        "psn_cert_type": "",
        "certno": "",
        "psn_name": "",
        "inst_id": instid,
        "admvs": admvs,
        "insuplc_admvs": insuplc_admvs ? insuplc_admvs : admvs,
  } 
  return hisrequest({
    url: '/getPatientInfo',
    method: 'post',
    data: {
      data: data
    }
  })
}

/**
 * 医保读卡接口
 * @param {Object} options - 读卡参数
 * @param {Object} options.patient - 患者信息（可选，当inst没有admvs时使用）
 * @returns {Promise} 读卡结果
 */
export function readCard(options = {}) {
  // 获取当前机构信息
  const inst = getHospital()
  
  // 检查inst是否有admvs信息
  const admvs = inst && inst.admvs ? String(inst.admvs).trim() : ''
  
  console.log('readCard called, inst:', inst, 'admvs:', admvs, 'options:', options)
  
  // 如果没有admvs信息，则虚拟返回患者卡片信息，跳过医保读卡逻辑
  if (!admvs) {
    console.log('No admvs, returning virtual card data')
    const patient = options && options.patient ? options.patient : {}
    const patientName = (patient.name && String(patient.name).trim()) || ''
    const patientIdCard = (patient.idCard && String(patient.idCard).trim()) || (patient.idcard && String(patient.idcard).trim()) || ''
    
    // 虚拟返回患者卡片信息，直接使用患者信息
    // 如果患者信息不完整，使用身份证号作为默认值，确保能通过验证
    // 这样可以直接使用患者卡片的信息带入收费信息里，跳过医保读卡逻辑
    const cardNumber = patientIdCard || patientName || 'DEFAULT_CARD'
    const cardIdentifyCode = patientIdCard || patientName || 'DEFAULT_CARD_ID'
    const idNumber = patientIdCard || 'DEFAULT_ID'
    const name = patientName || 'DEFAULT_NAME'
    
    const virtualData = {
      items: [{
        cardNumber: cardNumber,
        cardIdentifyCode: cardIdentifyCode,
        idNumber: idNumber,
        name: name
      }],
      baseinfo: {
        name: patientName || name,
        certNo: patientIdCard || idNumber,
        certno: patientIdCard || idNumber,
        idCard: patientIdCard || idNumber,
        idcard: patientIdCard || idNumber,
        mdtrt_cert_no: patientIdCard || idNumber,
        mdtrt_cert_type: '02'
      }
    }
    console.log('Virtual card data:', virtualData)
    return Promise.resolve(virtualData)
  }
  
  // 有admvs信息，正常调用医保读卡接口
  console.log('Has admvs, calling real readCard API')
  // 从options中提取请求参数，排除patient字段（patient只用于虚拟返回）
  const requestPayload = options && typeof options === 'object' ? { ...options } : {}
  delete requestPayload.patient
  return hisrequest({
    url: '/read-card',
    method: 'post',
    data: {
        "TypeCode": "03",
        ...requestPayload
    }
  })
}

export function queryChronicDisease(data) {
  return hisrequest({
    url: '/chronic-disease',
    method: 'post',
    data
  })
}

/**
 * 提交订单
 * @param {} data 
 * @returns 
 */
export function submitOrder(data) {
  return hisrequest({
    url: '/submit-order',
    method: 'post',
    data
  })
}

export function preSettle(data) {
  return hisrequest({
    url: '/pre-settle',
    method: 'post',
    data
  })
}

export function settle(data) {
  return hisrequest({
    url: '/settle',
    method: 'post',
    data
  })
}


export function settleCancel(data) {
  return hisrequest({
    url: '/settle-cancel',
    method: 'post',
    data
  })
}

/**
 * 2202 门诊挂号撤销（退挂号）
 * @param {Object} data - 撤销参数
 * @param {string} data.psn_no - 人员编号
 * @param {string} data.mdtrt_id - 就诊ID
 * @param {string} data.ipt_otp_no - 住院/门诊号
 * @param {string} data.fixmedinsCode - 定点医药机构编号
 * @param {string} data.fixmedinsName - 定点医药机构名称
 * @param {string} data.admvs - 就医地医保区划
 * @param {string} [data.insuplc_admdvs] - 参保地医保区划
 * @param {string} [data.exp_content] - 扩展内容
 * @returns {Promise<{ IsSuccess: boolean, Msg?: string }>} 撤销结果
 */
export function cancelMdtrt(data) {
  return hisrequest({
    url: '/cancel-mdtrt',
    method: 'post',
    data
  })
}

/**
 * 【2601】冲正交易
 * 因网络中断或超时导致双方数据不一致时，冲正取消对方数据
 * @param {Object} data - 冲正入参
 * @param {string} data.psn_no - 人员编号
 * @param {string} data.omsgid - 原发送方报文ID
 * @param {string} data.oinfno - 原交易编号（如2207/2208/2304等）
 * @returns {Promise} 冲正结果
 */
export function reversal(data) {
  return hisrequest({
    url: '/reversal',
    method: 'post',
    data
  })
}

/**
 * DIP上报接口 4101 门诊结算信息上传
 * @param {Object} data - 上报数据
 * @param {Object} data.settleInput - 结算输入信息
 * @param {Object} data.settleOutput - 结算输出信息
 * @returns {Promise} 上报结果
 */
export function report4101(data) {
  return hisrequest({
    url: '/report/dip',
    method: 'post',
    data
  })
}

/**
 * 3101 事前分析（医保审核-事前）
 * 在2203提交缴费单之后、预结算之前调用
 * @param {Object} data - 入参（Report3101Input），由后端GetReport3101InputAsync组装 + 前端补充机构信息
 * @returns {Promise<{ isSuccess: boolean, msg?: string }>} 上报结果
 */
export function report3101(data) {
  return hisrequest({
    url: '/pre-review',
    method: 'post',
    data
  })
}

/**
 * 3102 事中分析（医保审核-事中）
 * 在2206结算之后调用
 * @param {Object} data - 入参（Report3102Input），由后端GetReport3102InputAsync组装 + 前端补充机构信息
 * @returns {Promise<{ isSuccess: boolean, msg?: string }>} 上报结果
 */
export function report3102(data) {
  return hisrequest({
    url: '/detail-review',
    method: 'post',
    data
  })
}

/**
 * 3505 商品销售（溯源码上报）
 * @param {Object} data - 入参（Report3505Input）
 * @param {Object} data.selinfo - 商品销售信息（Report3505UploadInput）
 * @param {string} data.fixmedinsCode - 定点医药机构编号
 * @param {string} data.fixmedinsName - 定点医药机构名称
 * @param {string} data.admvs - 统筹区
 * @param {string} [data.insuplc_admdvs] - 参保地医保区划
 * @returns {Promise<{ IsSuccess: boolean, Msg?: string }>} 上报结果
 */
export function report3505(data) {
  return hisrequest({
    url: '/drug-sale',
    method: 'post',
    data
  })
}

/**
 * 5203 结算信息查询
 * @param {Object} data - 入参（Report5203Input）
 * @param {string} [data.fixmedinsCode] - 定点医药机构编号
 * @param {string} [data.fixmedinsName] - 定点医药机构名称
 * @param {string} [data.admvs] - 统筹区
 * @param {string} [data.insuplc_admdvs] - 参保地医保区划
 * @param {string} [data.psn_no] - 人员编号
 * @param {string} [data.setl_id] - 结算ID
 * @param {string} [data.mdtrt_id] - 就诊ID
 * @returns {Promise<Object>} 输出（Report5203Output，含结算费用分项）
 */
export function report5203(data) {
  return hisrequest({
    url: '/settlement-query',
    method: 'post',
    data
  })
}

/**
 * 5204 费用明细信息查询
 * @param {Object} data - 入参（Report5204Input）
 * @param {string} [data.fixmedinsCode] - 定点医药机构编号
 * @param {string} [data.fixmedinsName] - 定点医药机构名称
 * @param {string} [data.admvs] - 统筹区
 * @param {string} [data.psn_no] - 人员编号
 * @param {string} [data.setl_id] - 结算ID
 * @param {string} [data.mdtrt_id] - 就诊ID
 * @returns {Promise<{ isSuccess: boolean, msg?: string, feedetail?: Array }>} 输出（Report5204Output）
 */
export function report5204(data) {
  return hisrequest({
    url: '/fee-detail',
    method: 'post',
    data
  })
}

/**
 * 无医保模式保存收费信息
 * @param {Object} data - 收费数据
 * @returns {Promise} 保存结果
 */
export function saveChargeWithoutInsurance(data) {
  return authrequest({
    url: '/api/app/patient-payment/save-charge-without-insurance',
    method: 'post',
    data
  })
}

/**
 * 根据就诊凭证获取患者信息（支持身份证、社保卡、电子社保卡）
 * @param {Object} params - 读卡参数
 * @param {String} params.mdtrt_cert_type - 就诊凭证类型：01-电子社保卡，02-身份证，03-社保卡
 * @param {String} params.mdtrt_cert_no - 就诊凭证编号（01时填写电子凭证令牌，02时填写身份证号，03时填写社会保障卡卡号）
 * @param {String} params.card_sn - 卡序列号（就诊凭证类型为"03"时必填）
 * @param {String} params.psn_cert_type - 人员证件类型（就诊凭证类型为"01"和"03"时必填）
 * @param {String} params.certno - 证件号码（就诊凭证类型为"01"和"03"时必填）
 * @param {String} params.psn_name - 人员姓名
 * @param {String} params.inst_id - 机构ID
 * @param {String} params.admvs - 统筹区
 * @returns {Promise} 患者信息
 */
export function getPatientInfoByCard(params) {
  const {
    mdtrt_cert_type,
    mdtrt_cert_no,
    card_sn = '',
    psn_cert_type = '',
    certno = '',
    psn_name = '',
    inst_id,
    admvs = '',
  } = params || {}
  
  // 获取当前日期，格式：YYYY-MM-DD
  const today = new Date()
  const year = today.getFullYear()
  const month = String(today.getMonth() + 1).padStart(2, '0')
  const day = String(today.getDate()).padStart(2, '0')
  const begntime = `${year}-${month}-${day} 00:00:01`
  
  const data = {
    mdtrt_cert_type: mdtrt_cert_type || '02',
    mdtrt_cert_no: mdtrt_cert_no || '',
    card_sn: card_sn || '',
    begntime: begntime,
    psn_cert_type: psn_cert_type || '',
    certno: certno || '',
    psn_name: psn_name || '',
    inst_id: inst_id || '',
    admvs: admvs || '',
    insuplc_admvs: admvs || ''
  }
  
  return hisrequest({
    url: '/getPatientInfo',
    method: 'post',
    data: {
      data: data
    }
  })
}

